import { FC, PropsWithChildren } from 'react';

import PredefinedParamsContext from './context';

type TPredefinedParamsContext = 'menu' | 'provider' | 'source';

type PredefinedParamsProviderProps = {
  context: TPredefinedParamsContext;
};

const getPredefinedParams = (context: TPredefinedParamsContext) => {
  switch (context) {
    case 'provider':
      return [
        { value: 'channelIds' },
        { value: 'className' },
        { value: 'deeplinkQueryParams' },
        { value: 'deeplinkUrlBase_android', isUrl: true },
        { value: 'deeplinkUrlBase_ios', isUrl: true },
        { value: 'deeplinkUrlBase_web', isUrl: true },
        { value: 'fallbackUrl_android', isUrl: true },
        { value: 'fallbackUrl_ios', isUrl: true },
        { value: 'homeUrl', isUrl: true },
        { value: 'homeUrl_android', isUrl: true },
        { value: 'homeUrl_appletv', isUrl: true },
        { value: 'homeUrl_ios', isUrl: true },
        { value: 'homeUrl_web', isUrl: true },
        { value: 'packageName' },
        { value: 'popupTextType' },
        { value: 'traits' },
      ];
    case 'menu':
    case 'source':
    default:
      return [];
  }
};

export const PredefinedParamsProvider: FC<PropsWithChildren<PredefinedParamsProviderProps>> = ({
  children,
  context,
}) => {
  const predefinedParams = getPredefinedParams(context);

  const getDefsForParam = (paramKey?: string) =>
    predefinedParams.find(({ value }) => paramKey === value);

  const getFilteredParams = (omitFields: string[]) =>
    predefinedParams.filter(({ value }) => !omitFields.includes(value));

  const values = { getDefsForParam, predefinedParams, getFilteredParams };

  return (
    <PredefinedParamsContext.Provider value={values}>{children}</PredefinedParamsContext.Provider>
  );
};

export default PredefinedParamsProvider;
